import { render, staticRenderFns } from "./clipper-fixed.vue?vue&type=template&id=0926203c&scoped=true&"
import script from "./clipper-fixed.vue?vue&type=script&lang=js&"
export * from "./clipper-fixed.vue?vue&type=script&lang=js&"
import style0 from "./clipper-fixed.vue?vue&type=style&index=0&id=0926203c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926203c",
  null
  
)

export default component.exports